module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/Daoan/BackgroundofServiceRightsExplanation.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FDaoan%2FBackgroundofServiceRightsExplanation.png
// module id = NBzc
// module chunks = 93